import { render } from "./Fail.vue?vue&type=template&id=6224d921&ts=true"
import script from "./Fail.vue?vue&type=script&lang=ts"
export * from "./Fail.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/ticketcafe-widget/ticketcafe-widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__